<template>
  <div>
    <Teleport to="#fast-contact-title">Saisissez votre prénom et votre nom</Teleport>
    <div class="flex max-md:flex-col gap-4 py-8">
      <FastInput
        v-model="store.form.userContact.firstName"
        class="w-full"
        placeholder="Prénom"
        name="firstName"
        :maxlength="50"
        autofocus
      />
      <FastInput
        v-model="store.form.userContact.lastName"
        class="w-full"
        placeholder="Nom"
        name="lastName"
        :maxlength="50"
      />
    </div>
    <div class="mt-4 flex max-md:flex-col gap-3 items-center">
      <button class="btn font-semibold text-body" @click="$emit('goto', 'message')">Retour</button>
      <div class="grow"></div>
      <button
        class="btn btn-primary py-4 px-8 md:ml-auto max-md:w-full"
        :disabled="!completed"
        @click="$emit('goto', 'signupLogin')"
      >
        Continuer
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useMainStore } from '../stores/main'
import FastInput from '@/apps/shared/components/FastInput.vue'
const store = useMainStore()

const completed = computed(() => {
  return store.form.userContact.firstName.length > 0 && store.form.userContact.lastName.length > 0
})
</script>
